export const TableNamesEnum = {
  SERVED_ITEM_SETUP_TABLE: 'servedItemSetupTable',
  MODIFY_DAILY_DEPOSIT_TABLE: 'modifyDDTable',
  UNCLOSEDAY_MEAL_SUMMARY_TABLE: 'unclosedayMealSummaryTable',
  SERVED_ITEM_ACCESS_SETUP_TABLE: 'servedItemAccessSetupTable',
  PROCESSED_DOCUMENTS_TABLE: 'processedDocumentsTable',
  CEP_SETUP_TABLE: 'CEP_SetupTable',
  ITEM_MAINTENANCE_TABLE: 'itemMaintenanceTable',
  BID_PRICE_TABLE: 'bidPriceTable',
  ITEM_DETAIL_TABLE: 'itemDetailTable',
  FIFO_TABLE: 'fifoTable',
  TRANSACTION_DETAIL_TABLE: 'transactionDetailTable',
  PURCHASE_ORDER_TABLE: 'purchaseOrderTable',
  PURCHASE_ORDER_CREATE_EDIT_TABLE: 'purchaseOrderCreateEditTable',
  MANAGE_PROCESS_ORDER_ITEM_TABLE: 'manageProcessOrderItemTable',
  TRANSFER_ITEM_TABLE: 'transferItemTable',
  MANAGEPROCESSORDER_CREATEEDIT_ORDERITEMS_TABLE:
    'manageProcessOrderCreateEditOrderItemsTable',
  MANAGEPROCESSORDER_CREATEEDIT_SITEITEMS_TABLE:
    'manageProcessOrderCreateEditSiteItemsTable',
  TRANSFER_ORDER_TABLE: 'transferOrderTable',
  MANAGEPURCHASEORDER_CREATEEDIT_ORDERITEMS_TABLE:
    'managePurchaseOrderCreateEditOrderItemsTable',
  MANAGEPURCHASEORDER_CREATEEDIT_SITEITEMS_TABLE:
    'managePurchaseOrderCreateEditSiteItemsTable',
  COLOR_SETUP_TABLE: 'colorSetupTable',
  UPDATE_BID_DETAILS_TABLE: 'updateBidDetailsTable',
  USAGE_LIST_TABLE: 'usageListTable',
  USAGE_LIST_CREATE_EDIT_TABLE: 'usageListCreateEditTable',
  UPDATE_BID_PRICE_DETAILS_TABLE: 'updateBidPriceDetailsTable',
  PHYSICAL_LIST_TABLE: 'physicalListTable',
  PHYSICAL_LIST_CREATE_EDIT_TABLE: 'physicalListCreateEditTable',
  ADJUSTMENT_LIST_TABLE: 'adjustmentListTable',
  ADJUSTMENT_LIST_CREATE_EDIT_TABLE: 'adjustmentListCreateEditTable',
  ADJUSTMENT_LIST_VIEW_TABLE: 'adjustmentListViewTable',
  ASSIGN_ENTITIES_ITEM_GRID_TABLE: 'assignEntitiesItemGridTable',
  CUSTOM_QUERY_LIST_TABLE: 'customQueryListTable',
  UPDATE_OPEN_ORDERS_DETAILS: 'updateOpenOrderDetails',
  MNU_RECIPE_SEARCH_TABLE: 'menuRecipeSearchTable',
  ON_HAND_REPORT_FIFO_TABLE: 'onHandReportFiFoTable',
  ON_HAND_REPORT_TRANSACTION_DETAILS_TABLE:
    'onHandReportTransactionDetailsTable',
  TRANSACTION_SUMMARY_DETAIL_TABLE: 'transactionSummaryDetailTable',
  CREATE_TRANSACTION_SUMMARY_TABLE: 'createTransactionSummaryTable',
  ON_HAND_REPORT_ITEM_GRID_TABLE: 'onHandReportItemGridTable',
  ON_HAND_REPORT_SITE_GRID_TABLE: 'onHandReportSiteGridTable',
  ASSIGN_ENTITIES_SITE_GRID_TABLE: 'assignEntitiesSiteGridTable',
  ASSIGN_ENTITIES_USER_GRID_TABLE: 'assignEntitiesUserGridTable',
  ASSIGN_ENTITIES_STORAGE_LOCATION_ITEM_GRID_TABLE:
    'assignEntitiesStorageLocationItemGridTable',
  ASSIGN_ENTITIES_STORAGE_LOCATION_SITE_GRID_TABLE:
    'assignEntitiesStorageLocationSiteGridTable',
  ITEM_LISTING_REPORT_TABLE: 'itemListingReportTable',
  CK_KITCHEN_PREP_WORKSHEET_TABLE: 'ckKitchenPrepWorksheetTable',
  MNU_INGREDIENT_SEARCH_TABLE: 'menuIngredientSearchTable',
  MNU_RECIPE_INGREDIENT_TABLE: 'menuRecipeIngredientTable',
  CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_TABLE:
    'ckKitchenPrepWorksheetCreateEditTable',
  REVIEW_INCOMING_APPLICATIONS_TABLE: 'reviewIncomingApplicationsTable',
  FAMILY_MATCH_UTILITY_APPLICATIONS_TABLE:
    'FAMILY_MATCH_UTILITY_APPLICATIONS_TABLE',
  FAMILY_MATCH_UTILITY_STUDENTS_TABLE: 'FAMILY_MATCH_UTILITY_STUDENTS_TABLE',
  MANAGE_TRUCK_ROUTE_TABLE: 'manageTruckRouteTable',
  CK_PRINT_BARCODES_TABLE: 'ckPrintBarcodesTable',
  MANAGE_TRUCK_ROUTE_SCHEDULE_TABLE: 'manageTruckRouteScheduleTable',
  MANAGE_APPLICATION_TABLE: 'MANAGE_APPLICATION_TABLE',
  NETWORKFILTERING_TABLE: 'NETWORKFILTERING_TABLE',
  DC_UNMATCHED_UTILITY_UNMATCHED_TABLE: 'DC_UNMATCHED_UTILITY_UNMATCHED_TABLE',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/TableEnum.js